import chatSupportLogService from "./chatSupportLogService";
import csrOutreachService from "./csrOutreachService";

const approvalsService = {
  getPendingCount: async () => {
    const params = { approval_status: "pending", page: 1, limit: 1 };
    const [actRes, custRes, premRes] = await Promise.all([
      chatSupportLogService.getPendingActivityLogs(params).catch(() => ({ total: 0 })),
      chatSupportLogService.getPendingCustomerLogs(params).catch(() => ({ total: 0 })),
      csrOutreachService.getPremiumRequests({ ...params, status: "pending" }).catch(() => ({ total: 0 })),
    ]);

    return (actRes.total || 0) + (custRes.total || 0) + (premRes.total || 0);
  },
};

export default approvalsService;
